import Submit from '~/components/button/Submit';
import Form from '~/components/Form';
import Input from '~/components/form-controls/Input';
import {
  DISCOUNT_CODE_KEY,
  editActionTypeFormKey,
  useLoaderData,
} from './orderEditStage';

type LoaderData = Awaited<ReturnType<typeof useLoaderData>>;

export function AddDiscountCodeForm({
  data,
}: {
  data: Extract<LoaderData, { editType: 'ADD_DISCOUNT_CODE' }>;
}) {
  return (
    <Form name="addDiscountCodeForm">
      <input type="hidden" name={editActionTypeFormKey} value={data.editType} />
      <Input
        id="code"
        name={DISCOUNT_CODE_KEY}
        type="text"
        label="Discount Code"
        autoComplete="off"
        autoCapitalize="characters"
        required
        validationMessages={{
          valueMissing: 'Please enter a discount code.',
        }}
      />
      <Submit>Apply Code</Submit>
    </Form>
  );
}
